<nz-spin [nzSpinning]="loading$ | async">
  <!-- this button should appear in header -->
  <div class="header-with-cta without-border">
    <div class="cta-wrapper">
      <button
        nz-button
        type="button"
        nzType="primary"
        (click)="openAddReferenceMaterialDrawer()">
        Add Reference Material
      </button>
    </div>
  </div>
  <!-- this button should appear in header -->

  <nz-table
    #sortTable
    nzShowSizeChanger
    [nzData]="(referenceMaterials$ | async)?.result?.items ?? []"
    [nzFrontPagination]="false"
    [nzTotal]="total || 0"
    [(nzPageIndex)]="pageIndex"
    [nzPageSize]="pageSize"
    (nzQueryParams)="onQueryParamsChange($event)"
    [nzScroll]="{ x: '1100px', y: 'calc(100vh - 290px)' }">
    <thead>
      <tr>
        <th
          nzWidth="250px"
          [nzSortFn]="true"
          [title]="listOfColumn[0].title"
          nzColumnKey="name">
          {{ listOfColumn[0].title }}
        </th>
        <th
          nzWidth="300px"
          [nzSortFn]="true"
          [title]="listOfColumn[1].title"
          nzColumnKey="description">
          {{ listOfColumn[1].title }}
        </th>
        <th nzRight nzWidth="100px"></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let data of sortTable.data; let i = index">
        <td>
          <div class="with-file-icon">
            <svg-icon
              *ngIf="fileExtension(data.displayName) === 'pdf'"
              [title]="'PDF File'"
              src="/assets/icon/icon-pdf-file.svg"
              class="icon"></svg-icon>
            <svg-icon
              [title]="'Document File'"
              *ngIf="fileExtension(data.displayName) !== 'pdf'"
              src="/assets/icon/icon-doc.svg"
              class="icon"></svg-icon>
            <span>{{ data.name }}</span>
          </div>
        </td>
        <td>{{ data.description }}</td>
        <td nzRight>
          <div class="action-btn-wrapper">
            <button
              nz-button
              nzType="text"
              class="action-btn"
              (click)="downloadFile(data)">
              <svg-icon
                [title]="'Download Reference Material'"
                src="/assets/icon/icon-download.svg"
                class="icon s-20"></svg-icon>
            </button>
            <button
              nz-button
              nzType="text"
              class="action-btn"
              (click)="onDelete(data.id)">
              <svg-icon
                [title]="'Delete Reference Material'"
                src="/assets/icon/icon-trash.svg"
                class="icon s-20"></svg-icon>
            </button>
          </div>
        </td>
      </tr>
    </tbody>
  </nz-table>
</nz-spin>
<app-confirm-dialog
  [isVisible]="showConfirmDialog"
  [title]="'Delete Reference Material'"
  [message]="'Are you sure you want to delete? This action cannot be undone.'"
  [iconSrc]="'/assets/icon/icon-trash-red.svg'"
  [iconColor]="'red'"
  [cancelText]="'Cancel'"
  [confirmText]="'Delete'"
  [loading]="isDeleting"
  (confirmed)="handleDelete()"
  (cancelled)="handleCancel()"
  (closed)="handleCancel()">
</app-confirm-dialog>
